import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Tabs,
  Tab
} from '@material-ui/core';
import ViewColumn from 'helpers/ViewColumn';
import useLocalStorageTableCells from 'hooks/useLocalStorageTableCells';
import { useStyles } from '../../styles';
import { draftQuotesTableCells, recentQuotesTableCells } from './helpers';
import PatientActivityTable from './PatientActivityTable';
import RecentQuotesTable from './RecentQuotesTable';


const PatientActivity = ({
  setSelectedTab,
  selectedTab
}) => {
  const classes = useStyles();
  const { draftedQuotes, currentQuoteCustomer } = useSelector((state: IReduxState) => state.quote);

  const { headTableCells: draftHeadTableCells, setHeadTableCells: setDraftHeadTableCells } = useLocalStorageTableCells('draftPatientHistoryTableCells', draftQuotesTableCells);
  const { headTableCells: recentHeadTableCells, setHeadTableCells: setRecentHeadTableCells } = useLocalStorageTableCells('recentQuotesHistoryTableCells', recentQuotesTableCells);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (selectedTab === 'draft_patient_history') {
      setDraftHeadTableCells(draftHeadTableCells);
    } else {
      setRecentHeadTableCells(recentHeadTableCells);
    }
  }, [selectedTab]);

  const currentHeadTableCells = selectedTab === 'draft_patient_history' ? draftHeadTableCells : recentHeadTableCells;
  const currentSetHeadTableCells = selectedTab === 'draft_patient_history' ? setDraftHeadTableCells : setRecentHeadTableCells;

  return (
    <>
      <div className="flex align-center">
        <Tabs
          value={selectedTab}
          onChange={handleChangeTab}
          variant="scrollable"
          scrollButtons="auto"
          classes={{
            indicator: classes.tabIndicator,
          }}
        >
          <Tab
            label={<span className="whitespace-no-wrap">Saved Quotes</span>}
            value="draft_patient_history"
            className={selectedTab === 'draft_patient_history' ? classes.activeTab : classes.inactiveTab}
          />
          <Tab
            label={<span className="whitespace-no-wrap">Recent Quotes</span>}
            value="recent_quotes_history"
            className={selectedTab === 'recent_quotes_history' ? classes.activeTab : classes.inactiveTab}
          />
        </Tabs>

        {selectedTab === 'draft_patient_history' &&
        <div style={{ marginLeft: 'auto' }}>
          <ViewColumn
            storageKey={selectedTab === 'draft_patient_history' ? 'draftPatientHistoryTableCells' : 'recentQuotesHistoryTableCells'}
            tableCells={currentHeadTableCells}
            setHeadTableCells={currentSetHeadTableCells}
          />
        </div>}
      </div>
      {selectedTab === 'draft_patient_history' &&
        <PatientActivityTable
          data={draftedQuotes}
          selectedTab={selectedTab}
          headTableCells={draftHeadTableCells}
        />
      }
      {selectedTab === 'recent_quotes_history' &&
        <RecentQuotesTable
          email={currentQuoteCustomer.email}
          searchFields={[
            {field: 'increment_id', name: 'Quote ID'},
            {field: 'created_by_doctor', name: 'Created By'},
          ]}
        />
      }
    </>
  );
};

export default PatientActivity;
